import React, { FC } from 'react'
import styles from 'styles/components/header.module.scss'

type Props = {
  handleMenuClose: () => void
}

const HeaderNavBackground: FC<Props> = React.memo((props) => {
  const { handleMenuClose } = props
  return <div className={styles.nav__background} onClick={handleMenuClose} />
})

export default HeaderNavBackground
